import * as React from 'react';
import { StandardTextField } from '@jeremyling/react-material-ui-form-builder';

// eslint-disable-next-line no-unused-vars
const TextField = (field, methods, f) => {
    const asyncValidate = field?.asyncValidate;
    const attribute = field?.attribute;

    const handleBlur = React.useCallback(async () => {
        if (!asyncValidate || !methods) return;
        const value = methods.getValues(attribute);
        if (!value) return;
        try {
            const isValid = await asyncValidate(value);
            if (!isValid) {
                methods.setError(attribute, {
                    type: 'asyncValidate',
                    message: 'Unit with this name already exists',
                });
            } else {
                const currentError = methods.formState.errors?.[attribute];
                if (currentError?.type === 'asyncValidate') {
                    methods.clearErrors(attribute);
                }
            }
        } catch {
            // Silently ignore validation errors
        }
    }, [asyncValidate, methods, attribute]);

    const fieldConfig = React.useMemo(() => {
        if (methods?.getValues(field?.attribute) === null) {
            methods?.setValue(field?.attribute, '');
        }
        return {
            ...field,
            props: {
                ...field.props,
                disabled: field.props?.inputProps?.readOnly,
                onBlur: asyncValidate ? handleBlur : undefined,
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field, handleBlur]);

    return <StandardTextField field={fieldConfig} methods={methods} />;
};

export default TextField;
